import type { QueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

/**
 * The reads behind the financing lock: the financing read (its application
 * and actions) and every read that reports the lock or contract readiness.
 * Any lender's application command that can lock or unlock selections
 * invalidates them. Not awaited.
 */
export const invalidateSolarFinancingLockReaders = (
  queryClient: QueryClient,
  proposalId: string,
): void => {
  for (const queryKey of [
    queryKeys.solarProposal.financing(proposalId),
    queryKeys.solarProposal.byId(proposalId),
    queryKeys.solarProposal.productOffering(proposalId),
    queryKeys.solarProposal.compute(proposalId),
    queryKeys.solarProposal.utility(proposalId),
    queryKeys.solarProposal.consumption(proposalId),
    queryKeys.solarProposal.aurora(proposalId),
    queryKeys.solarProposal.systemPricing(proposalId),
    queryKeys.solarProposal.contract(proposalId),
  ]) {
    void queryClient.invalidateQueries({ queryKey, exact: true })
  }
}
